import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {debounce} from "lodash";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {SelectField} from "./FilterComponentStyles";
import {CourierDetailBox} from "../../shiftManagement/Components/ShiftEntryModal/CourierDetailBox/CourierDetailBox";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {Spin} from "antd";

const CourierFilter = ({hideTitle = false, value, onChange, selectMarginBottom = "20px"}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [searchText, setSearchText] = useState("");
    const debounceTimeout = 800;

    const [loading, data, ,] = useFetch({
        fetchFn: stores.courierStore.getCourierList.bind(null, {
            limit: 10,
            skip: 0,
            statuses: [],
            types: [],
            searchText
        }),
        dependencies: [searchText],
        condition: !stores.meStore.checkRole("isCompanyUser"),
        initialCall: false
    });

    const onSearchUser = useMemo(() => {
        const loadOptions = value => {
            setSearchText(value);
        };
        return debounce(loadOptions, debounceTimeout);
    }, [debounceTimeout]);

    return (
        <>
            {!hideTitle && <h5>{t("fields.courier", {ns: "common"})}</h5>}
            <SelectField
                allowClear
                showSearch
                placeholder={""}
                value={value}
                mb={selectMarginBottom}
                onSearch={onSearchUser}
                onChange={(value, key) => {
                    onChange(value, key?.key);
                }}
                loading={loading}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props["data-tckn"].toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props["data-cellPhone"].toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent={
                    loading ? (
                        <Spin />
                    ) : searchText ? (
                        "Kurye bulunamadı"
                    ) : (
                        "İsim, tckn, telefon giriniz"
                    )
                }
            >
                {data?.rows &&
                    data?.rows.length > 0 &&
                    arrayAlphabeticalSort([...data?.rows], "fullname").map(courier => (
                        <SelectField.Option
                            key={courier._id}
                            value={`${courier._id}`}
                            data-tckn={courier.tckn}
                            data-cellPhone={courier.cellPhone}
                            data-testid="courierSelect_option"
                        >
                            {courier.fullname}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </>
    );
};

export default CourierFilter;
